import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useApp } from "../../../hooks/AppProvider";
import { EditDeleteCell, NewRowTemplate, SelectCell, Table } from "../../../components/BasicComponents";

function GameDetailsConstraintsTable({ keyId, title, values, constraints, placeholder, onDelete, onAdd }) {
    return (
        <Table headers={[title, ""]}>
            {constraints && constraints.map(constraint => (
                <GameDetailsConstraintsRow key={keyId + ":" + constraint.id} id={constraint.id} values={values} valueId={constraint.valueId} onDelete={onDelete} />
            ))}
            {constraints.length < values.length && (<GameDetailsConstraintNewRow values={values} constraints={constraints} onAdd={onAdd} placeholder={placeholder} />)}   
        </Table>
    )
}

function GameDetailsConstraintsRow({ id, values, valueId, onDelete }) {

    const value = values.find(val => val.id+"" === valueId+"");

    const onDelete0 = () => {
        if(window.confirm("Vous êtes sur le point de supprimer la contrainte: " + (value?.label ?? "Inconnue") + ". Souhaitez-vous continuer ?")) {
            onDelete(id);
        }
    };

    return (
        <tr>
            <td>{value?.label ?? "Inconnue"}</td>
            <EditDeleteCell onDelete={onDelete0}/>
        </tr>
    );
}

function GameDetailsConstraintNewRow({ values, constraints, onAdd, placeholder }) {

    const [newValueId, setNewValueId] = useState();
    const [avaliableValues, setAvaliableValues] = useState([]);

    useEffect(() => {
        const avaliable = [];
        for(let value of values) {
            if(constraints.find(val => val.valueId+"" === value.id+"") === undefined)
                avaliable.push(value);
        }

        setAvaliableValues(avaliable);
    }, [values, constraints]);

    const onAdd0 = (e) => {
        onAdd(newValueId+"");
        setNewValueId("");
    };

    return (
        <NewRowTemplate>
            <SelectCell value={newValueId || ""}
                options={avaliableValues.map(val => ({id: val.id, label: val.label}))}
                onChange={e => { setNewValueId(e.target.value); }}
                placeholder={placeholder}
                disabled={avaliableValues.length===0}
                />
            <td>
                <button onClick={onAdd0} disabled={avaliableValues.length===0} >Ajouter</button>
            </td>
        </NewRowTemplate>
    );
}

function GameDetails() {

    const params = useParams();
    const app = useApp();
    const [gameId, setGameId] = useState(params.gameId);

    const [genderConstraints, setGenderConstraints] = useState([]);
    const [calculationConstraints, setCalculationConstraints] = useState([]);
    const [gradeConstraints, setGradeConstraints] = useState([]);
    const [teacherConstraints, setTeacherConstraints] = useState([]);

    const [genders, setGenders] = useState([]);
    const [calculations, setCalculations] = useState([]);
    const [grades, setGrades] = useState([]);
    const [teachers, setTeachers] = useState([]);

    const [game, setGame] = useState();

    //load
    useEffect(() => {
        app.sendGet("/game/details/" + gameId, (data) => {
            if(data.success === false) {
                app.navigate("/404")
                return;
            }

            setGame(data);
        });

        app.sendGet("/game/details/" + gameId + "/constraints/gender", (data) => {
            setGenderConstraints(data);
        });

        app.sendGet("/game/details/" + gameId + "/constraints/calculation", (data) => {
            setCalculationConstraints(data);
        });

        app.sendGet("/game/details/" + gameId + "/constraints/grade", (data) => {
            setGradeConstraints(data);
        });

        app.sendGet("/game/details/" + gameId + "/constraints/teacher", (data) => {
            setTeacherConstraints(data);
        });

        app.sendGet("/student/genders", (data) => {
            setGenders(data);
        });

        app.sendGet("/game/calculations", (data) => {
            setCalculations(data);
        });

        app.sendGet("/student/grades", (data) => {
            setGrades(data);
        });

        app.sendGet("/user/list", (data) => {
            setTeachers(data);
        });
    }, [gameId]);


    const onAddGenderConstraint = (genderId) => {
        if(app.emptyCheck(genderId) || "")
            return alert("Le nouveau genre autorisé n'est pas définie");

        app.sendPost("/game/details/" + gameId + "/constraints/gender/add", {gender_id: genderId}, (data) => {
            if(data.success === false) {
                return alert("Une erreur s'est produite [0]"); 
            }

            setGenderConstraints([...genderConstraints, data]);
        });
    };

    const onDeleteGenderConstraint = (constraintId) => {
        if(app.emptyCheck(constraintId))
            return alert("Une erreur s'est produite [1]");

        app.sendPost("/game/details/" + gameId + "/constraints/gender/delete", {id: constraintId}, (data) => {
            if(data.success === false)
                return alert("Une erreur s'est produite [2]");

            setGenderConstraints(genderConstraints.filter(val => val.id !== constraintId));
        });
    };


    const onAddCalculationConstraint = (calculationId) => {
        
        if(app.emptyCheck(calculationId) || calculationId === "undefined")
            return alert("La nouvelle période autorisé n'est pas définie");

        app.sendPost("/game/details/" + gameId + "/constraints/calculation/add", {calculation_id: calculationId}, (data) => {
            if(data.success === false) {
                return alert("Une erreur s'est produite [10]"); 
            }

            setCalculationConstraints([...calculationConstraints, data]);
        });
    };

    const onDeleteCalculationConstraint = (constraintId) => {
        if(app.emptyCheck(constraintId))
            return alert("Une erreur s'est produite [11]");

        app.sendPost("/game/details/" + gameId + "/constraints/calculation/delete", {id: constraintId}, (data) => {
            if(data.success === false)
                return alert("Une erreur s'est produite [12]");

            setCalculationConstraints(calculationConstraints.filter(val => val.id !== constraintId));
        });
    };


    const onAddGradeConstraint = (gradeId) => {
        
        if(app.emptyCheck(gradeId) || gradeId === "undefined")
            return alert("Le nouveau niveau autorisé n'est pas définie");

        app.sendPost("/game/details/" + gameId + "/constraints/grade/add", {grade_id: gradeId}, (data) => {
            if(data.success === false) {
                return alert("Une erreur s'est produite [20]"); 
            }

            setGradeConstraints([...gradeConstraints, data]);
        });
    };

    const onDeleteGradeConstraint = (constraintId) => {
        if(app.emptyCheck(constraintId))
            return alert("Une erreur s'est produite [21]");

        app.sendPost("/game/details/" + gameId + "/constraints/grade/delete", {id: constraintId}, (data) => {
            if(data.success === false)
                return alert("Une erreur s'est produite [22]");

            setGradeConstraints(gradeConstraints.filter(val => val.id !== constraintId));
        });
    };


    const onAddTeacherConstraint = (teacherId) => {
        if(app.emptyCheck(teacherId) || teacherId === "undefined")
            return alert("La nouvelle classe autorisé n'est pas définie");

        app.sendPost("/game/details/" + gameId + "/constraints/teacher/add", {teacher_id: teacherId}, (data) => {
            if(data.success === false) {
                return alert("Une erreur s'est produite [30]"); 
            }

            setTeacherConstraints([...teacherConstraints, data]);
        });
    };

    const onDeleteTeacherConstraint = (constraintId) => {
        if(app.emptyCheck(constraintId))
            return alert("Une erreur s'est produite [31]");

        app.sendPost("/game/details/" + gameId + "/constraints/teacher/delete", {id: constraintId}, (data) => {
            if(data.success === false)
                return alert("Une erreur s'est produite [32]");

            setTeacherConstraints(teacherConstraints.filter(val => val.id !== constraintId));
        });
    };

    return (
        <>
            {game && (
                <div>
                    <h1>Détail du jeu: {game.name}</h1>
                    <h2>Contraintes de genre</h2>
                    <GameDetailsConstraintsTable
                        values={genders.map(val => ({id: val.id, label: val.display_name}))}
                        constraints={genderConstraints.map(val => ({id: val.id, valueId: val.gender_id}))}
                        keyId={"gender_constraint"}
                        title={"Genre autorisé"}
                        placeholder={"- Choisir un genre -"}
                        onAdd={onAddGenderConstraint}
                        onDelete={onDeleteGenderConstraint}
                    />
                    <hr />
                    <h2>Contraintes de période</h2>
                    <GameDetailsConstraintsTable
                        values={calculations.map(val => ({id: val.id, label: getCalculationLabel(val)}))}
                        constraints={calculationConstraints.map(val => ({id: val.id, valueId: val.calculation_id}))}
                        keyId={"calculation_constraint"}
                        title={"Période autorisé"}
                        placeholder={"- Choisir une période -"}
                        onAdd={onAddCalculationConstraint}
                        onDelete={onDeleteCalculationConstraint}
                    />
                    <hr />
                    <h2>Contraintes de niveau</h2>
                    <GameDetailsConstraintsTable
                        values={grades.map(val => ({id: val.id, label: val.display_name}))}
                        constraints={gradeConstraints.map(val => ({id: val.id, valueId: val.grade_id}))}
                        keyId={"grade_constraint"}
                        title={"Niveau autorisé"}
                        placeholder={"- Choisir un niveau -"}
                        onAdd={onAddGradeConstraint}
                        onDelete={onDeleteGradeConstraint}
                    />
                    <hr />
                    <h2>Contraintes de classe</h2>
                    <GameDetailsConstraintsTable
                        values={teachers.map(val => ({id: val.id, label: val.display_name}))}
                        constraints={teacherConstraints.map(val => ({id: val.id, valueId: val.teacher_id}))}
                        keyId={"teacher_constraint"}
                        title={"Classe autorisé"}
                        placeholder={"- Choisir une classe -"}
                        onAdd={onAddTeacherConstraint}
                        onDelete={onDeleteTeacherConstraint}
                    />
                    </div>
            )}
        </>
    )

}

function getCalculationLabel(calculation) {
    return getCalculationDateLabel(calculation.calc) + " -> " + getCalculationDateLabel(calculation.release);
}

function getCalculationDateLabel(calculationDate) {
    let label = "";
    switch(calculationDate[0]) {
        case 0:
            label = "lun "
            break;
        case 1:
            label = "mar "
            break;
        case 2:
            label = "mer "
            break;
        case 3:
            label = "jeu "
            break;
        case 4:
            label = "ven "
            break;
        case 5:
            label = "sam "
            break;
        case 6:
            label = "dim"
            break;
    }

    let hou = calculationDate[1];
    if((hou+"").length === 1)
        hou = "0" + hou;

    let min = calculationDate[2];
    if((min+"").length === 1)
        min = "0" + min;

    label += hou + ":" + min;
    return label;
}

export default GameDetails;